

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _credit = require('xo-models/src/credit');

var _checkout = require('xo-models/src/checkout');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$capeRedirectUtil', function () {
    return {
        handleCapeRouting: function handleCapeRouting(checkoutSession, checkoutCart, token) {
            var fundingInstruments = void 0;
            var isCreditInWallet = void 0;

            if (checkoutCart.isBillingNoPurchase()) {
                fundingInstruments = checkoutSession.futurePaymentInstruments;
                isCreditInWallet = checkoutSession.futurePayment && checkoutSession.futurePayment.isCreditInWallet;
            } else {
                fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
                isCreditInWallet = fundingInstruments && _squid.$util.find(fundingInstruments, function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            var checkoutAppData = _checkout.$CheckoutAppDataModel.instance(token);
            var creditDataModel = _credit.$CreditDataModel.instance(token);
            var installmentModel = _credit.$CreditInstallmentModel.instance(token);

            var isCapeReturnKey = creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');
            var isPPCEligible = checkoutSession.creditOffer;

            if (_squid.$locale.country !== checkoutAppData.get('merchant.merchant_country')) {
                creditDataModel.setCrossBorder(true);
            }

            function handleRedirect() {
                // User does not have any FI in wallet but they choose to pay in full.
                // Show add card contingency page instead of redirecting to CAPE.
                if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {
                    return _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                }

                // Handle case where it was timeout and status is to go back to cape
                else if (isCreditInWallet || isCapeReturn || creditDataModel.payInFull) {
                        return _uiRouter.$state.go('checkout.review');
                    }

                    // Handle acquisition customer send to CAPE
                    else if (!isCreditInWallet && isPPCEligible) {
                            return _uiRouter.$state.go('checkout.redirectToCape');
                        } else {
                            // show error message
                            return _uiRouter.$state.go('checkout.review');
                        }
            }

            // 2nd button, cross border, installment offer selected in API -- we cannot honor any offer the user chose, so must clear offer
            if (checkoutAppData.is_second_button_txn && creditDataModel.isCrossBorder() && installmentModel.get('meta.populated')) {
                installmentModel.action('delete', {
                    success: function success(result) {
                        _logger.$logger.info('patch_cart_installment_success');
                        _credit.$CreditInstallmentModel.create(token); // Clear cache for this token
                        handleRedirect();
                    },
                    error: function error(err) {
                        _logger.$logger.error('patch_cart_installment_fail', err);
                        _uiRouter.$state.go('checkout.genericError', {
                            code: 'DELETE_CREDIT_OPTION_ERROR'
                        });
                    }
                });
            } else {
                handleRedirect();
            }
        }
    };
});

_squid.$util;

_squid.$locale;

_uiRouter.$state;

_logger.$logger;

_credit.$CreditDataModel;

_credit.$CreditInstallmentModel;

_checkout.$CheckoutAppDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/util.js
// module id = ./pages/xo-login/util.js
// module chunks = 0